import { useEffect, useState } from 'react';

function useInstagram(photoCount) {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    async function fetchInstagramPosts() {
      try {
        const res = await fetch('/.netlify/functions/instagram', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ photoCount }),
        });
        const data = await res.json();

        setPosts(await data);
      } catch (error) {
        console.error(error);
        setPosts([]);
      }
    }
    fetchInstagramPosts();
  }, [photoCount]);
  return posts;
}

export { useInstagram };
